import { useState } from "react"

export const useBranchFormHandling = () => {

    const [formData,setFormData] = useState({

        name: "",
        code: "",
        bankId: "",
        iplBankId: "",
        countryId: "",
        stateId: "",
        districtId: "",
        cityId: "",
        pinCodeId: "",
        addressLine1: "",
        addressLine2: "",
        landmark: "",
        active: true,


        nameStatus: "unchecked",
        codeStatus: "unchecked",
        bankIdStatus: "unchecked",
        iplBankIdStatus: "unchecked",
        countryIdStatus: "unchecked",
        stateIdStatus: "unchecked",
        districtIdStatus: "unchecked",
        cityIdStatus: "unchecked",
        pinCodeIdStatus: "unchecked",
        addressLine1Status: "unchecked",
        addressLine2Status: "unchecked",

    });    

    const [contacts, setContacts] = useState([
        {
        contactType: "",
        value: "",
        isActive: true,

        contactTypeStatus: "unchecked",
        valueStatus: "unchecked",
        }
    ]);
    
    //Handle Change Function
    const handleChange = (event, selectEvent) => {
        let formState ={...formData};

        if(event && event.target){
            switch(event.target.name){
                case "name": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,80})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "iplBankId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,30})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "code": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,30})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "addressLine1": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{5,60})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "addressLine2": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{0,60})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "landmark": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{0,40})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "value": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,80})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                default: {

                    formState[event.target.name] = event.target.value;
                    formState[event.target.name + "Status"] =
                    event.target.value === "" ? "unchecked" : "success";
                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        else if(event?.target === undefined && selectEvent){
            switch(selectEvent.name){
                
                case "countryId": {
                    const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,70})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "stateId": {
                    const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "districtId": {
                    const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "cityId": {
                    const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "contactType": {
                    const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                    
                default: {
                    
                    formState[selectEvent.name] = event;
                    formState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
                    break;
                }
            }
            
            formState[selectEvent.name] = event;
        }
        setFormData(formState);
    
    }

    //Submit Validation
    const checkAllFields = () => {
        let allowSubmit = false;

        if (
        formData.nameStatus === "success" &&
        formData.codeStatus === "success" &&
        formData.bankIdStatus === "success" &&
        formData.countryIdStatus === "success" &&
        formData.stateIdStatus === "success" &&
        formData.districtIdStatus === "success" &&
        formData.cityIdStatus === "success" &&
        formData.pinCodeIdStatus === "success" &&
        formData.addressLine1Status === "success"
        ) {
        allowSubmit = true;
        } else {
        allowSubmit = false;
        }

        return allowSubmit;
    };

    return{
        formData,
        setFormData,
        contacts,
        setContacts,
        handleChange,
        checkAllFields
    }
}